import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAfternoon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 256,
	height: 72,
	viewBox: "0 0 256 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_16794_322312)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M256 0.234375H0V72.2344H256V0.234375Z",
				fill: "url(#paint0_linear_16794_322312)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.649 69.5143C260.112 69.5143 275.079 54.5472 275.079 36.0843C275.079 17.6214 260.112 2.6543 241.649 2.6543C223.186 2.6543 208.219 17.6214 208.219 36.0843C208.219 54.5472 223.186 69.5143 241.649 69.5143Z",
				fill: "#F2E111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M239.285 71.4401C237.36 71.4401 235.785 70.5201 235.785 69.4001C235.785 68.2801 234.21 67.3601 232.285 67.3601H228.605C226.68 67.3601 225.105 66.4401 225.105 65.3201C225.105 64.2001 226.68 63.2801 228.605 63.2801H242.965C244.89 63.2801 246.465 62.3351 246.465 61.1801C246.465 60.0251 244.89 59.0801 242.965 59.0801H213.365C211.44 59.0801 209.865 60.0251 209.865 61.1801C209.865 62.3351 211.08 63.2801 212.565 63.2801C214.05 63.2801 215.265 64.2001 215.265 65.3201C215.265 66.4401 213.69 67.3601 211.765 67.3601H205.805C203.88 67.3601 202.305 68.3051 202.305 69.4601C202.305 70.6151 203.36 71.5601 204.645 71.5601C205.93 71.5601 206.985 72.4801 206.985 73.6001C206.985 74.7201 208.56 75.6401 210.485 75.6401H243.565C245.49 75.6401 247.065 74.6951 247.065 73.5401C247.065 72.3851 245.49 71.4401 243.565 71.4401H239.285Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M232.468 21.5799C232.468 20.4249 230.893 19.4799 228.968 19.4799H222.648C220.723 19.4799 219.148 18.7249 219.148 17.7999C219.148 16.8749 220.253 16.1199 221.608 16.1199C222.963 16.1199 224.068 15.1749 224.068 14.0199C224.068 12.8649 222.493 11.9199 220.568 11.9199H202.248C200.323 11.9199 198.748 12.8649 198.748 14.0199C198.748 15.1749 200.323 16.1199 202.248 16.1199H206.768C208.693 16.1199 210.268 16.8749 210.268 17.7999C210.268 18.7249 208.693 19.4799 206.768 19.4799H196.128C194.203 19.4799 192.628 20.3149 192.628 21.3399C192.628 22.3649 191.548 23.1999 190.228 23.1999C188.908 23.1999 187.828 24.1449 187.828 25.2999C187.828 26.4549 189.403 27.3999 191.328 27.3999H202.088C204.013 27.3999 205.588 26.5649 205.588 25.5399C205.588 24.5149 207.163 23.6799 209.088 23.6799H228.968C230.893 23.6799 232.468 22.7349 232.468 21.5799Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_16794_322312",
		x1: 128,
		y1: 72.2344,
		x2: 128,
		y2: .234375,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1CE4F9" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#098BDB"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16794_322312",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 72,
			fill: "white"
		})
	})] })]
});
export default SvgAfternoon;
